import { Box } from '@mui/material'
import FormDatePickerInput from '../../components/Forms/FormDatePickerInput'
import FormInput from '../../components/Forms/FormInput'
import { SectionTitleTypography } from '../../components/Typographies/styles'

type DriverInfoProps = {
    isDisabled?: boolean
    isNew: boolean
}

const DriverInfo = ({ isDisabled = false, isNew }: DriverInfoProps) => {
    return (
        <Box>
            <Box sx={{ mb: '16px' }}>
                <SectionTitleTypography>Driver Info</SectionTitleTypography>
            </Box>
            <FormInput
                name="driverDetail.licenceNumber"
                label="License Number"
                required
                disabled={isDisabled}
                maxLength={50}
            />
            <FormDatePickerInput
                name="driverDetail.licenceExpiry"
                label="License Expiry Date"
                required
                disabled={isDisabled}
                minDate={new Date().toISOString().split('T')[0]}
                disablePast={true}
                format="YYYY-MM-DD"
            />
        </Box>
    )
}

export default DriverInfo

